export default __webpack_public_path__ + "static/media/18.1ab418ff.mp3";